/**
 * 实时线索
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("realTimeCluesModule", [
    "realTimeCluesRouterModule", //实时线索总路由
    "plannedCluesModule", //计划性线索模块
    "suddenCluesModule" //突发性线索模块
]).
controller("realTimeCluesCtrl", [function() {

}]);